var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTabGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 7.5C11.175 7.5 11.8687 6.8 11.8687 5.9375C11.8687 5.075 11.175 4.375 10.3125 4.375C9.45 4.375 8.75 5.075 8.75 5.9375C8.75 6.8 9.45 7.5 10.3125 7.5ZM5.625 6.875C6.6625 6.875 7.49375 6.0375 7.49375 5C7.49375 3.9625 6.6625 3.125 5.625 3.125C4.5875 3.125 3.75 3.9625 3.75 5C3.75 6.0375 4.5875 6.875 5.625 6.875ZM10.3125 8.75C9.16875 8.75 6.875 9.325 6.875 10.4688V11.875H13.75V10.4688C13.75 9.325 11.4563 8.75 10.3125 8.75ZM5.625 8.125C4.16875 8.125 1.25 8.85625 1.25 10.3125V11.875H5.625V10.4688C5.625 9.9375 5.83125 9.00625 7.10625 8.3C6.5625 8.1875 6.0375 8.125 5.625 8.125Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTabGroup);
export default __webpack_public_path__ + "static/media/icon_tab_group.bd1b8217.svg";
export { ForwardRef as ReactComponent };